import gql from 'graphql-tag';

export const WS_FILE_METADATA_UPDATE = gql`
  subscription($appointmentId: String!) {
    fileUpdate(appointmentId: $appointmentId) {
      metaDataId
      mimeType
      encoding
      name
      size
      comment
      status
      thumbnail
      downloadRoute
    }
  }
`;
